import { useQuery } from '@apollo/client';
import React from 'react';
import { formatDateTime } from '@corti/date';
import { useTranslation } from '@corti/i18n';
import { repositories } from 'core/repositories';
import { Base, Typography } from 'lib/cortiUI';
import { useInteraction } from '../context';
import { FindSimilarInteractions } from './FindSimilarInteractions';
import MetadataLoader from './MetadataLoader';
import { CopyableProperty, ExpandableProperties, SingleProperty } from './components';
import { getCaseMetadataQuery } from './graphql';
export const Metadata = ({ caseID }) => {
    const { t } = useTranslation('caseView', { keyPrefix: 'metadata' });
    const { interaction, isLoading } = useInteraction();
    const { data: caseMetadataData, loading: isCaseMetadataLoading } = useQuery(getCaseMetadataQuery, {
        variables: {
            id: caseID,
        },
    });
    if ((!interaction && isLoading) || isCaseMetadataLoading) {
        return React.createElement(MetadataLoader, null);
    }
    if (!interaction)
        return null;
    const interactionOwner = repositories.users.getUser(interaction.interaction_owner);
    return (React.createElement(Base, { display: "grid", gridTemplateRows: "1fr auto" },
        React.createElement(Base, { display: "grid", gridTemplateRows: "auto auto 1fr", gap: 6 },
            React.createElement(Typography, { variant: "subtitle1", color: "default" }, t('interactionDetails', 'Interaction Details')),
            React.createElement(Base, { display: "grid", gap: 6 },
                interaction.call_started_at && (React.createElement(SingleProperty, { title: t('date', 'Date'), value: formatDateTime(new Date(interaction.call_started_at)) })),
                interactionOwner && (React.createElement(SingleProperty, { title: t('agent', 'Agent'), value: interactionOwner.name })),
                interaction.interaction_type && (React.createElement(SingleProperty, { title: t('interactionType', 'Interaction Type'), value: interaction.interaction_type }))),
            (caseMetadataData === null || caseMetadataData === void 0 ? void 0 : caseMetadataData.case.customProperties) &&
                !!Object.entries(caseMetadataData === null || caseMetadataData === void 0 ? void 0 : caseMetadataData.case.customProperties).length && (React.createElement(ExpandableProperties, { title: t('customProperties', 'Custom properties'), items: Object.entries(caseMetadataData === null || caseMetadataData === void 0 ? void 0 : caseMetadataData.case.customProperties).map(([key, value]) => ({
                    title: key,
                    value: value,
                })) }))),
        React.createElement(Base, { display: "flex" },
            React.createElement(Base, { display: "flex", flexDirection: "column", gap: 4 },
                React.createElement(FindSimilarInteractions, null),
                interaction.call_external_id && (React.createElement(CopyableProperty, { title: t('externalId', 'External ID'), value: interaction.call_external_id })),
                React.createElement(CopyableProperty, { title: t('interactionId', 'Interaction ID'), value: caseID })))));
};
